import moment from "moment";
/**
 * Function to generate unique ID
 * @returns Number (Unique ID)
 */
export const getUniqueId = () => {
  return Date.now();
};

export const normalizeDate = (val) => {
  if (!val) return null;

  // already a string (YYYY-MM-DD)
  if (typeof val === "string") return val;

  // moment object
  if (moment.isMoment(val)) return val.format("YYYY-MM-DD");

  // JS Date
  if (val instanceof Date) {
    return moment(val).format("YYYY-MM-DD");
  }

  return null;
};

export const getNestedValue = (obj, path) => {
  const keys = path.split('.');
  let value = obj;

  for (let key of keys) {
    if (Array.isArray(value)) {
      // extract value from each item in array
      value = value.map(item => item?.[key]).flat();
    } else {
      value = value?.[key];
    }
  }

  return value;
};
